import { useState } from 'react'
import { useLanguage } from '@/hooks/useLanguage'

const LANGUAGE_WHITE_LIST_FOR_CGU = ['en', 'en-US', 'en-SA', 'ar-SA']

type DialogState = 'add-by-vitale-card' | 'carte-vitale-infos' | 'cgu' | 'none'

export function useDialogState() {
  const language = useLanguage()
  const [dialogState, setDialogState] = useState<DialogState>(!LANGUAGE_WHITE_LIST_FOR_CGU.includes(language) ? 'cgu' : 'none')

  const closeDialog = () => setDialogState('none')

  return {
    closeDialog,
    dialogState,
    setDialogState,
  }
}
